export default function getFieldsValuesByKey(keys, item) {
    if (!Array.isArray(item?.fields)) return null;
    const values = item.fields.filter(({key: itemKey}) => [keys].flat().includes(itemKey));

    if (values.length === 1) return values[0].value;
    if (values.length > 1) return values.map(({value}) => value);
    return null;
}
